import { render, staticRenderFns } from "./DesenvolvimentoAplicativosItajai.vue?vue&type=template&id=7ba297e9&scoped=true"
import script from "./DesenvolvimentoAplicativosItajai.vue?vue&type=script&lang=js"
export * from "./DesenvolvimentoAplicativosItajai.vue?vue&type=script&lang=js"
import style0 from "./DesenvolvimentoAplicativosItajai.vue?vue&type=style&index=0&id=7ba297e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba297e9",
  null
  
)

export default component.exports